<template>
	<Layout>
		<div class="order-page">
			<div class="page-content" v-loading.fullscreen.lock="pageLoading">
				<!-- 页面头部 -->
				<div class="page-header">
					<h2>订单管理</h2>
					<p>查看和管理您的订单信息</p>
				</div>

				<!-- 订单类型切换 -->
				<div class="tab-section">
					<el-tabs v-model="teamType" @tab-click="handleTeamChange" class="custom-tabs">
						<el-tab-pane v-for="item in ENUM.HEADER_TAB" :key="item.value" :label="item.label"
							:name="item.value.toString()"></el-tab-pane>
					</el-tabs>
				</div>

				<!-- 搜索筛选区域 -->
				<el-card class="card-container" shadow="never">
					<div class="platform-filter">
						<!-- <span class="filter-label">平台筛选：</span> -->
						<el-tabs v-model="platformTab" class="platform-tabs" @tab-click="handlePlatformChange">
							<el-tab-pane
								v-for="item in ENUM.PLAT_LIST"
								:key="item.value"
								:label="item.label"
								:name="item.value.toString()"
							></el-tab-pane>
						</el-tabs>
					</div>
					<div class="search-section">
						<el-form :inline="true" :model="formInline" class="search-form" label-width="100px">
							<el-form-item label="订单号或标题">
								<el-input v-model="formInline.keyword" placeholder="请输入订单编号或商品标题"
									prefix-icon="el-icon-search" @input="handleKeywordInput" @change="refreshOrderData(true)" clearable></el-input>
							</el-form-item>
							<el-form-item label="按付款时间">
								<el-date-picker v-model="formInline.range" type="daterange" align="right" unlink-panels
									range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
									:picker-options="pickerOptions" value-format="timestamp" clearable
									@change="dateChange">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button @click="refreshOrderData(true)" icon="el-icon-search">搜索</el-button>
								<el-button @click="clearSearch" icon="el-icon-refresh">重置</el-button>
								<el-button @click="downLoad" icon="el-icon-download">订单导出</el-button>
							</el-form-item>
						</el-form>

					</div>
				</el-card>

				<!-- 选中标签 -->
				<div v-if="selectTag" class="selected-tag">
					<el-tag type="warning" closable @close="closeTag" size="medium">
						<i class="el-icon-search"></i>
						筛选条件：{{ selectTag }}
					</el-tag>
				</div>

				<!-- 数据统计 -->
				<el-card class="card-container statistics-card" shadow="never" v-loading="statLoading">
					<div class="statistics-header">数据统计</div>
					<div class="statistics-grid">
						<div v-for="item in statItems" :key="item.key" class="statistic-item">
							<div class="statistic-label">{{ item.label }}</div>
							<div class="statistic-value" :class="item.className">
								<span v-if="item.currency" class="currency-symbol">¥</span>{{ item.value }}
							</div>
						</div>
					</div>
				</el-card>

				<!-- 数据表格 -->
				<el-card class="card-container" shadow="never">
					<el-tabs v-model="statusTab" class="order-status-tabs" @tab-click="handleStatusChange">
						<el-tab-pane
							v-for="item in ENUM.STATUS_LIST"
							:key="item.value"
							:label="item.label"
							:name="item.value.toString()"
						></el-tab-pane>
					</el-tabs>
					<el-table v-loading="loading" :data="tableData" tooltip-effect="light" style="width: 100%" stripe
						:header-cell-style="{ background: '#f8f9fa', color: '#606266', fontWeight: 'bold' }"
						:row-key="getRowKey">
						<el-table-column prop="order_sn" label="订单号" min-width="180">
							<template slot-scope="scope">
								<div class="">
									<div class="flex align-center">{{ scope.row.order_sn }} <i
											class="el-icon-document-copy m-l-5 pointer"
											@click="copyOrder(scope.row.order_sn)"></i></div>
									<el-tag size="small"
										:type="scope.row.status == 2 ? 'danger' : scope.row.status == 1 ? (scope.row.is_lock == 1 ? 'success' : 'warning') : 'info'">{{
										teamType == 1 ? scope.row.status_label : scope.row.order_status
										}}</el-tag>
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="title" label="商品信息" min-width="300">
							<template slot-scope="scope">
								<div class="goods-info flex pointer" @click="handleGoodsClick(scope.row)">
									<div class="goods-img m-r-10"
										v-if="teamType == 1 || teamType == 2 && scope.row.privacy_order == 0">
										<img class="radius8" width="80" :src="scope.row.picUrl" alt="">
										<div class="cancel-img flex align-center justify-center"
											v-if="scope.row.status == 3">
											<img width="70"
												src="https://img.huajuanyun.com/utools/2024/1011/1728629867477.png"
												alt="">
										</div>
									</div>
									<div class="goods-name flex column font16 justify-between">
										<div>
											<span v-if="teamType == 2 && scope.row.privacy_order == 1">
												<img height="16" class="type-icon"
													:src="`https://h5.dhcc.wang/images/goods_detail/ic_shop_${scope.row.type}.png`"
													alt="">成员开启隐私保护
											</span>
											<el-tooltip v-else class="item" :content="scope.row.full_title">
												<div class="flex">
													<span class="text-line-1 color1">
														<img class="type-icon" height="18"
															:src="`https://h5.dhcc.wang/images/goods_detail/sharepage_type_${scope.row.type}.png`"
															alt="">{{ scope.row.full_title }}
													</span>
													<el-tag v-if="!selectTag" class="pointer m-l-5" type="warning"
														effect="light" size="mini"
														@click.stop="selectTitle(scope.row.full_title)">筛选</el-tag>
												</div>

											</el-tooltip>
											<div class="flex align-center font14 m-t-5 color9"
												v-if="scope.row.own_shop && scope.row.own_shop.trim() !== ''"><i class="iconfont icon-shop m-r-3"></i>
												{{ scope.row.own_shop }}</div>
										</div>
										<div class="font14 color3 m-t-10">
											付款金额：<span class="font14">￥</span><span class="font16 color1 bold">{{
												scope.row.payment_price }}</span>
										</div>
									</div>
								</div>
							</template>

						</el-table-column>
						<el-table-column prop="createtime" label="订单时间" min-width="180">
							<template slot-scope="scope">
								<div class="font14">付款时间: {{ scope.row.createtime || '-' }}</div>
								<div class="font14">收货时间: {{ scope.row.order_receive_time_text || '-' }}</div>
								<div class="font14" v-if="scope.row.status != 3">
									结算时间: {{ scope.row.settlement_at || ' - ' }}
								</div>
								<div v-if="scope.row.status == 3 && scope.row.failuretime" class="font14">
									失效时间: {{ scope.row.failuretime_text || '-' }}
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="teamType == 2" prop="avatar" label="下单人" min-width="180">
							<template slot-scope="scope">
								<div class="flex">
									<img class="radius50" width="42" height="42" :src="scope.row.avatar" alt="">
									<div class="flex column justify-between m-l-10">
										<div class="font15 color1">昵称：{{ scope.row.nickname }}</div>
										<div class="font13">UID：{{ scope.row.buyer_id }}</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="price" :label="teamType == 1 ? '预估佣金' : '团队分成'" min-width="100">
							<template slot-scope="scope">
								<div class="commission-cell">
									<div>
										<span class="text-red">￥</span><span class="font16 text-red">{{
											scope.row.price }}</span>
									</div>
									<div class="commission-rate">{{ formatCommissionRate(scope.row) }}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="结算状态" min-width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.status != 3"
									:type="scope.row.settlement_status == 1 ? 'success' : 'info'">{{
									scope.row.settlement_status_text }}</el-tag>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="buyer_id" label="扩展信息" min-width="150">
							<template slot-scope="scope">
								<div>
									<template v-if="scope.row.extend_text">
										<el-tag v-for="(tag, index) in parseExtendText(scope.row.extend_text)"
											:key="index" size="mini" :type="getTagType(tag)" class="extend-tag">{{ tag
											}}</el-tag>
									</template>
									<span v-else>-</span>
								</div>
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<div class="pagination-wrapper">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]"
							:page-size="pagination.pageSize" :total="pagination.total" @size-change="handleSizeChange"
							@current-change="handleCurrentChange"></el-pagination>
					</div>
				</el-card>
			</div>
		</div>
		<GoodsDetailHandler ref="goodsHandler" :team-type="parseInt(teamType)" @loading-change="handleLoadingChange" />
		<OrderDownload ref="downloadReport" :isShow="downloadShow" :teamType="teamType" :parames="downLoadParames"
			@close="closeDownload" />
	</Layout>
</template>

<script>
import { ENUM } from '@/utils/enum'
import Layout from '@/components/Layout/index'
import GoodsDetailHandler from '@/components/GoodsDetailHandler'
import OrderDownload from '@/components/OrderDownload'
import { getOrderList, getFansOrder, getOrderStat } from '@/api/public'
import { formatTime,getDayRangeBySetHours } from '@/utils/timeTransfer'

function getDefaultPaymentRange() {
	const end = new Date()
	const start = new Date()
	start.setMonth(start.getMonth() - 3)
	const range = getDayRangeBySetHours(start, end)
	return {
		range: [range.start, range.end],
		timestamp: [Math.floor(range.start / 1000), Math.floor(range.end / 1000)]
	}
}

export default {
	components: {
		Layout,
		GoodsDetailHandler,
		OrderDownload
	},
	data() {
		const defaultPaymentRange = getDefaultPaymentRange()
		return {
			ENUM,
			tableData: [],
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				status: 0,
				keyword: '',
				range: defaultPaymentRange.range,
				timestamp: defaultPaymentRange.timestamp
			},
			orderStat: {
				total_num: 0,
				failure_num: 0,
				receive_num: 0,
				order_num: 0,
				payment_price: 0,
				estimated_effect: 0
			},
			statLoading: false,
			statRequestSeq: 0,
			type: 0,
			platformTab: '0',
			teamType: '1',
			statusTab: '0',
			tableHeight: 500,
			loading: true,
			monthList: [],
			selectTag: '',
			pageLoading: false,
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			downloadShow: false,
			downLoadParames:{}
		}
		
	},
	computed: {
		statItems() {
			return [
				{ key: 'total_num', label: '总订单', value: this.formatStatNumber(this.orderStat.total_num) },
				{ key: 'order_num', label: '有效订单', value: this.formatStatNumber(this.orderStat.order_num), className: 'is-success' },
				{ key: 'failure_num', label: '失效订单', value: this.formatStatNumber(this.orderStat.failure_num), className: 'is-danger' },
				{ key: 'receive_num', label: '已收货订单', value: this.formatStatNumber(this.orderStat.receive_num) },
				{ key: 'payment_price', label: '有效付款金额', value: this.formatStatMoney(this.orderStat.payment_price), currency: true },
				{ key: 'estimated_effect', label: '有效预估佣金', value: this.formatStatMoney(this.orderStat.estimated_effect), currency: true, className: 'is-income' }
			]
		}
	},
	created() {
		this.tableHeight = window.innerHeight - 294
	},
	mounted() {
		this.monthList = this.getRecentMonths()
		this.refreshOrderData(false)
	},
	methods: {
		formatTime,
		formatStatNumber(value) {
			const number = Number(value || 0)
			return Number.isFinite(number) ? number.toLocaleString('zh-CN') : '0'
		},
		formatStatMoney(value) {
			const number = Number(value || 0)
			return Number.isFinite(number) ? number.toLocaleString('zh-CN', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}) : '0.00'
		},
		formatCommissionRate(row) {
			const commission = Number(row && row.price)
			const paymentAmount = Number(row && row.payment_price)
			if (!Number.isFinite(commission) || !Number.isFinite(paymentAmount) || paymentAmount <= 0) {
				return '0.0%'
			}
			return `${((commission / paymentAmount) * 100).toFixed(1)}%`
		},
		getCommonFilterParams() {
			return {
				type_big: this.type,
				order_sn: this.formInline.keyword,
				pay_start: this.formInline.timestamp.length > 0 ? this.formInline.timestamp[0] : '',
				pay_end: this.formInline.timestamp.length > 1 ? this.formInline.timestamp[1] : ''
			}
		},
		getListFilterParams() {
			return {
				...this.getCommonFilterParams(),
				status: this.formInline.status,
				pcweb: 1
			}
		},
		getOrderStatistics() {
			const requestSeq = ++this.statRequestSeq
			this.statLoading = true
			const params = {
				...this.getCommonFilterParams(),
				user_type: this.teamType == 1 ? 0 : 1
			}
			return getOrderStat(params).then(res => {
				if (requestSeq !== this.statRequestSeq) return
				const data = res && res.data ? res.data : {}
				this.orderStat = {
					total_num: data.total_num || 0,
					failure_num: data.failure_num || 0,
					receive_num: data.receive_num || 0,
					order_num: data.order_num || 0,
					payment_price: data.payment_price || 0,
					estimated_effect: data.estimated_effect || 0
				}
			}).catch(error => {
				if (requestSeq !== this.statRequestSeq) return
				console.error('获取订单统计失败:', error)
			}).finally(() => {
				if (requestSeq === this.statRequestSeq) {
					this.statLoading = false
				}
			})
		},
		getRecentMonths() {
			const months = [];
			const currentDate = new Date();

			for (let i = 0; i < 4; i++) {
				const tempDate = new Date(currentDate);
				tempDate.setMonth(currentDate.getMonth() - i);

				const year = tempDate.getFullYear();
				const month = String(tempDate.getMonth() + 1).padStart(2, '0');
				months.push(`${year}-${month}`);
			}

			return months.reverse(); // 按时间顺序排列
		},
		getList(isOnce = false) {
			this.loading = true
			if (isOnce) {
				this.pagination.currentPage = 1
			}
			let params = {
				...this.getListFilterParams(),
				page: this.pagination.currentPage,
				pagesize: this.pagination.pageSize
			}, httpUrl

			if (this.teamType == 1) {
				httpUrl = getOrderList
			} else {
				httpUrl = getFansOrder
			}
			httpUrl(params, isOnce).then(res => {
				this.loading = false
				// 确保每个数据项都有唯一的key，避免重复key警告
				const list = res.data.list || []
				this.tableData = list.map((item, index) => {
					// 使用多个字段组合生成稳定的唯一key
					const uniqueKey = [
						item.order_sn || '',
						item.order_id || '',
						item.goods_id || '',
						item.createtime || '',
						index
					].join('_')

					return {
						...item,
						uniqueKey
					}
				})
				this.pagination.total = res.data.total
			}).catch(err => {
				this.loading = false
			})
		},
		refreshOrderData(isOnce = true) {
			this.getList(isOnce)
			this.getOrderStatistics()
		},
		// 处理tab切换
		handleTeamChange(tab) {
			this.teamType = tab.name
			this.refreshOrderData(true)
		},
		// 处理平台切换  
		handlePlatformChange(tab) {
			this.type = Number(tab.name)
			this.refreshOrderData(true)
		},
		handleStatusChange(tab) {
			this.formInline.status = Number(tab.name)
			this.getList(true)
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val
			this.getList(true)
		},
		handleCurrentChange(val) {
			this.pagination.currentPage = val
			this.getList()
		},
		clearSearch() {
			const defaultPaymentRange = getDefaultPaymentRange()
			this.selectTag = ''
			this.type = 0
			this.platformTab = '0'
			this.statusTab = '0'
			this.formInline = {
				status: 0,
				keyword: '',
				range: defaultPaymentRange.range,
				timestamp: defaultPaymentRange.timestamp
			}
			this.refreshOrderData(true)
		},
		copyOrder(val) {
			this.$copyText(val).then(() => {
				this.$message.success('复制成功')
			}, () => {
				this.$message.error('复制失败，请自行选中复制')
			})
		},
		selectTitle(val) {
			this.selectTag = val
			this.formInline.keyword = val
			this.refreshOrderData(true)
		},
		handleKeywordInput(value) {
			if (value !== this.selectTag) {
				this.selectTag = ''
			}
		},
		closeTag() {
			this.selectTag = ''
			this.formInline.keyword = ''
			this.refreshOrderData(true)
		},
		handleGoodsClick(item) {
			this.$refs.goodsHandler.handleGoodsClick(item)
		},

		handleLoadingChange(loading) {
			this.pageLoading = loading
		},

		// 获取表格行的唯一key
		getRowKey(row, index) {
			// 使用多个字段组合确保唯一性，处理重复order_sn的情况
			if (row.uniqueKey) {
				return row.uniqueKey
			}

			// 组合多个字段生成唯一key
			const keyParts = [
				row.order_sn || '',
				row.order_id || '',
				row.goods_id || '',
				row.createtime || '',
				index
			]
			return keyParts.join('_')
		},

		// 解析扩展信息HTML内容
		parseExtendText(htmlText) {
			if (!htmlText) return []

			// 创建临时DOM元素解析HTML
			const tempDiv = document.createElement('div')
			tempDiv.innerHTML = htmlText

			// 获取所有span标签的内容
			const spans = tempDiv.querySelectorAll('span')
			const tags = []

			spans.forEach(span => {
				const text = span.textContent || span.innerText || ''
				if (text.trim()) {
					tags.push(text.trim())
				}
			})

			return tags
		},

		// 根据标签内容返回不同的tag类型
		getTagType(tagText) {
			// 简单返回随机颜色类型，保持视觉多样性
			const types = ['', 'success', 'info', 'warning', 'danger']
			const hash = tagText.split('').reduce((a, b) => {
				a = ((a << 5) - a) + b.charCodeAt(0)
				return a & a
			}, 0)
			return types[Math.abs(hash) % types.length]
		},
		dateChange(e) {
			this.formInline.timestamp = []
			if (e && e.length > 0) {
				let obj = getDayRangeBySetHours(e[0],e[1])
				this.formInline.timestamp.push(Math.floor(obj.start/1000))
				this.formInline.timestamp.push(Math.floor(obj.end / 1000))
			} 
			this.refreshOrderData(true)
		},
		downLoad(){
			this.downloadShow = true
			this.downLoadParames = {
				status: this.formInline.status,
				type_new: this.type,
				timestamp: this.formInline.timestamp,
				range: this.formInline.range,
			}
			this.$refs.downloadReport.init()
		},
		closeDownload(){
			this.downloadShow = false
		}

	},

	filters: {
		filterSales(val) {
			let num = Number(val || 0)
			if (isNaN(num)) return val || 0
			return num > 9999 ? (Math.floor(num / 10000) + '万') : num
		}
	},
	watch: {
	},

}
</script>

<style scoped lang="scss">
.order-page {
	padding: 20px;
	min-height: calc(100vh - 60px);
	background-color: #f8f9fa;
}

.page-content {
	width: 100%;
	margin: 0 auto;
}

.page-header {
	margin: 24px 0;

	h2 {
		margin: 0 0 8px 0;
		font-size: 24px;
		font-weight: 600;
		color: #303133;
	}

	p {
		margin: 0;
		color: #909399;
		font-size: 14px;
	}
}

.card-container {
	margin-bottom: 20px;
	border-radius: 8px;
	border: 1px solid #ebeef5;

	::v-deep .el-card__body {
		padding: 20px;
	}
}

// .tab-section {
// 	margin-bottom: 20px;
// 	background: white;
// 	border-radius: 8px;
// 	border: 1px solid #ebeef5;
// 	padding: 0 20px;
// }

.custom-tabs {
	::v-deep .el-tabs__nav-wrap::after {
		margin: 0;
		border-bottom: none;
	}

	::v-deep .el-tabs__item {
		font-size: 18px;
		font-weight: 600;
		height: 60px;
		line-height: 60px;
		color: #606266;
		padding: 0 30px;

		&.is-active {
			color: var(--main-bg-color);
			font-weight: 700;
		}

		&:hover {
			color: var(--main-bg-color);
		}
	}

	::v-deep .el-tabs__active-bar {
		display: none;
	}

	::v-deep .el-tabs__item {
		position: relative;

		&.is-active {
			position: relative;

			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
				width: 30px;
				height: 4px;
				background-color: var(--main-bg-color);
				border-radius: 2px;
				z-index: 2;
			}
		}

		&:nth-child(2) {
			padding-left: 30px !important;
		}

		&:last-child {
			padding-right: 30px !important;
		}
	}

	::v-deep .el-tabs__nav-wrap {
		&::after {
			height: 0;
		}
	}
}

.search-section {
	display: flex;
	align-items: center;
	justify-content: space-between;

	.search-form {
		::v-deep .el-form-item {
			margin-bottom: 0;
		}

		::v-deep .el-form-item__label {
			font-weight: 500;
			color: #606266;
		}

		::v-deep .el-input__inner,
		::v-deep .el-select .el-input__inner {
			border-radius: 6px;
		}

		.el-button {
			margin-right: 10px;
			border-radius: 6px;

			&:last-child {
				margin-right: 0;
			}
		}
	}
}

.filter-divider {
	height: 1px;
	margin: 18px 0;
	background: #ebeef5;
}

.platform-filter {
	display: flex;
	align-items: center;
	min-width: 0;
	margin-bottom: 20px;

	.filter-label {
		font-weight: 500;
		color: #606266;
		margin-right: 16px;
		white-space: nowrap;
	}
}

.platform-tabs {
	flex: 1;
	min-width: 0;
	width: 0;

	::v-deep .el-tabs__header {
		margin: 0;
	}

	::v-deep .el-tabs__nav-wrap {
		overflow-x: auto;
		padding: 0 !important;
		scrollbar-width: none;
		-webkit-overflow-scrolling: touch;

		&::-webkit-scrollbar {
			display: none;
		}

		&::after {
			height: 1px;
			background-color: #ebeef5;
		}
	}

	::v-deep .el-tabs__nav-scroll {
		overflow: visible;
	}

	::v-deep .el-tabs__nav {
		display: flex;
		float: none;
		transform: none !important;
	}

	::v-deep .el-tabs__item {
		flex: 0 0 auto;
		height: 40px;
		padding: 0 18px;
		font-size: 16px;
		line-height: 40px;
		color: #333333;

		&.is-active,
		&:hover {
			color: var(--main-bg-color);
		}
	}

	::v-deep .el-tabs__active-bar {
		background-color: var(--main-bg-color);
	}

	::v-deep .el-tabs__nav-prev,
	::v-deep .el-tabs__nav-next {
		display: none;
	}
}

.order-status-tabs {
	margin-bottom: 18px;

	::v-deep .el-tabs__header {
		margin: 0;
	}

	::v-deep .el-tabs__item {
		height: 42px;
		padding: 0 24px;
		font-size: 15px;
		line-height: 42px;
		color: #606266;

		&.is-active,
		&:hover {
			color: var(--main-bg-color);
		}
	}

	::v-deep .el-tabs__active-bar {
		background-color: var(--main-bg-color);
	}

	::v-deep .el-tabs__nav-wrap::after {
		height: 1px;
		background-color: #ebeef5;
	}
}

.selected-tag {
	margin-bottom: 20px;

	.el-tag {
		padding: 0 16px;
		border-radius: 6px;
		font-size: 15px;

		i {
			margin-right: 4px;
		}
	}
}

.statistics-card {
	.statistics-header {
		margin-bottom: 18px;
		font-size: 16px;
		font-weight: 600;
		color: #303133;
	}

	.statistics-grid {
		display: grid;
		grid-template-columns: repeat(6, minmax(0, 1fr));
	}

	.statistic-item {
		min-width: 0;
		padding: 4px 20px;
		border-right: 1px solid #ebeef5;

		&:first-child {
			padding-left: 4px;
		}

		&:last-child {
			padding-right: 4px;
			border-right: none;
		}
	}

	.statistic-label {
		margin-bottom: 10px;
		font-size: 13px;
		color: #909399;
	}

	.statistic-value {
		overflow: hidden;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.2;
		color: #303133;
		text-overflow: ellipsis;

		&.is-success {
			color: #67c23a;
		}

		&.is-danger {
			color: #f56c6c;
		}

		&.is-income {
			color: #e6a23c;
		}
	}

	.currency-symbol {
		margin-right: 2px;
		font-size: 15px;
		font-weight: 500;
	}
}

.commission-cell {
	line-height: 1.35;
	font-weight: bold;
	.commission-rate {
		margin-top: 3px;
		color: #333333;
		font-size: 14px;
	}
}

.pagination-wrapper {
	display: flex;
	justify-content: center;
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid #ebeef5;
}

// 表格优化样式
::v-deep .el-table {
	.el-table__header-wrapper {
		.el-table__header {
			th {
				background-color: #f8f9fa;
				border-bottom: 2px solid #ebeef5;
			}
		}
	}

	.el-table__body-wrapper {
		.el-table__row {
			&:hover {
				background-color: #f8f9fa;
			}
		}
	}
}

// 商品信息样式优化
.goods-info {
	align-items: flex-start;

	.goods-img {
		position: relative;
		border-radius: 8px;
		overflow: hidden;
		flex-shrink: 0;
		width: 80px;
		height: 80px;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 8px;
		}

		.cancel-img {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background-color: rgba(0, 0, 0, 0.3);
			border-radius: 8px;

			img {
				width: 90% !important;
				height: 90% !important;
				object-fit: contain;
			}
		}
	}

	.goods-name {
		flex: 1;
		min-width: 0;

		.type-icon {
			margin-right: 4px;
			vertical-align: middle;
		}

		.text-line-1 {
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			overflow: hidden;
			word-break: break-all;
			line-height: 1.4;
		}
	}
}

// 扩展信息标签样式
.extend-tag {
	margin-right: 4px;
	margin-bottom: 4px;
	font-size: 12px;
}

// 响应式设计
@media (max-width: 1200px) {
	.page-content {
		max-width: 100%;
		padding: 0 10px;
	}

	.search-form {
		::v-deep .el-row {
			.el-col {
				margin-bottom: 16px;
			}
		}
	}

	.statistics-card {
		.statistics-grid {
			grid-template-columns: repeat(3, minmax(0, 1fr));
			row-gap: 24px;
		}

		.statistic-item:nth-child(3) {
			border-right: none;
		}
	}
}

@media (max-width: 768px) {
	.order-page {
		padding: 10px;
	}

	.platform-filter {
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

		.filter-label {
			margin-bottom: 12px;
		}
	}

	.platform-tabs {
		width: 100%;
	}

	.search-form {
		::v-deep .el-form-item {
			margin-bottom: 10px !important;
		}
	}

	.statistics-card {
		.statistics-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			row-gap: 20px;
		}

		.statistic-item {
			padding: 2px 12px;

			&:nth-child(odd) {
				padding-left: 2px;
				border-right: 1px solid #ebeef5;
			}

			&:nth-child(even) {
				padding-right: 2px;
				border-right: none;
			}
		}

		.statistic-value {
			font-size: 20px;
		}
	}
}
</style>
